module.exports = __webpack_public_path__ + "static/media/funkyplane.37c9b6c0.jpg";